import { IFood, MenuUpgrade } from "../models/IFood";
import { FoodCategory } from "../models/IFoodCategory";
import { configWithUserFileToken, configWithUserToken } from "./config";

export const getFoodCategories = () => {
  return configWithUserToken.get<FoodCategory[]>("FoodCategory");
};

export const postFoodCategory = (item: FoodCategory, image?: File) => {
  const form = new FormData();
  form.append("FoodCategoryNameTr", item.foodCategoryNameTr);
  form.append("FoodCategoryNameEn", item.foodCategoryNameEn);
  form.append("Priority", String(item.priority ?? 0));
  if (image) form.append("Image", image);
  return configWithUserFileToken.post("FoodCategory", form);
};

export const updateFoodCategory = (id: string, item: Omit<FoodCategory, 'id' | 'foodCategoryImageUrl'>, image?: File, removeImage?: boolean) => {
  const form = new FormData();
  form.append("FoodCategoryNameTr", item.foodCategoryNameTr);
  form.append("FoodCategoryNameEn", item.foodCategoryNameEn);
  form.append("Priority", String(item.priority ?? 0));
  if (image) form.append("Image", image);
  // Backend henüz bu alanı işlemiyor (yalnızca replace-or-keep destekliyor);
  // RemoveImage desteği eklenince bu satır çalışır hale gelecek.
  if (removeImage) form.append("RemoveImage", "true");
  return configWithUserFileToken.put(`FoodCategory/${id}`, form);
};

export const deleteFoodCategory = (id: string) =>
  configWithUserToken.delete(`FoodCategory/${id}`);

export const getAllFood = (restaurantId: string) => {
  return configWithUserToken.get<IFood[]>(
    "Menu/MenuListByRestourantId/" + restaurantId
  );
};

export const getFoodById = (foodId: string) => {
  return configWithUserToken.get<IFood>(
    "Menu/" + foodId
  );
};

const buildFoodFormData = (food: IFood, file?: File): FormData => {
  const form = new FormData();
  form.append("FoodNameTr", food.foodNameTr);
  form.append("FoodNameEn", food.foodNameEn);
  form.append("foodPrice", String(food.foodPrice));
  form.append("restourantId", food.restourantId);
  form.append("foodCategoryId", food.foodCategoryId);
  form.append("currencyId", food.currencyId);
  if (food.foodImagePath)     form.append("foodImagePath", food.foodImagePath);
  if (food.foodContents)      form.append("foodContents", food.foodContents);
  if (food.foodDescriptionTr) form.append("foodDescriptionTr", food.foodDescriptionTr);
  if (food.foodDescriptionEn) form.append("foodDescriptionEn", food.foodDescriptionEn);
  if (food.foodIsEnabled !== undefined) form.append("foodIsEnabled", String(food.foodIsEnabled));
  if (food.menuUpgrade?.length) form.append("MenuUpgrade", JSON.stringify(food.menuUpgrade));
  if (food.allergyIds?.length)  food.allergyIds.forEach(id => form.append("AllergyIds", id));
  if (file) form.append("file", file);
  return form;
};

export const postFood = (food: IFood, file?: File) => {
  const form = buildFoodFormData(food, file);
  return configWithUserFileToken.post("Menu", form, {
    headers: { "Content-Type": undefined },
  });
};

export const updateFood = (food: IFood) => {
  // foodImagePath bilerek gönderilmez: backend alan null değilse üzerine yazar ve formda
  // tutulan yol, resim ayrıca yüklendikten sonra bayatlar — yeni resmi eski/boş yolla ezerdi.
  // Resim yalnız Menu/UploadFoodImageById ucuyla değişir.
  const { foodImagePath: _ignored, ...rest } = food;
  const payload = {
    ...rest,
    menuUpgrade: food.menuUpgrade?.map(({ id, ...rest }) => (id ? { id, ...rest } : rest)),
  };
  return configWithUserToken.put("Menu/" + food.id, JSON.stringify(payload));
};

export const updateFoodPhoto = (id: string , file:File) => {
  const formData = new FormData();
  formData.append("file", file);
    return configWithUserFileToken.put("Menu/UploadFoodImageById/"+id , formData);
};

export const updateFoodMenuUpgrade = (foodId: string, upgrades: any[]) =>
  configWithUserToken.put(`Menu/UpdateFoodMenuUpgradeByFoodId/${foodId}`, JSON.stringify(upgrades));

export const deleteFood = (foodId: string) =>
  configWithUserToken.delete(`Menu/${foodId}`);

export interface IMenuStatusResult {
  restourantId: string;
  isEnabled: boolean;
  /** Restoranın toplam yemek sayısı */
  totalCount: number;
  /** Bu çağrının gerçekten değiştirdiği yemek sayısı (zaten o durumda olanlar sayılmaz) */
  updatedCount: number;
}

/** Bir restoranın bütün yemeklerini tek çağrıda açar ya da kapatır. */
export const setMenuStatusByRestaurant = (restaurantId: string, isEnabled: boolean) =>
  configWithUserToken.put<IMenuStatusResult>(
    `Menu/MenuStatusByRestourantId/${restaurantId}`,
    { isEnabled }
  );

export const translateToEnglish = (text: string) =>
  configWithUserToken.post<string>("Translate/ToEnglish", JSON.stringify(text), {
    headers: { "Content-Type": "application/json" },
  });
